import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "./HoverHelpText.css";

interface HoverHelpTextProps {
	helpText: string;
}

export const HoverHelpText: React.FC<HoverHelpTextProps> = ({ helpText }) => {
	const renderTooltip = (props: React.ComponentProps<typeof Tooltip>) => (
		<Tooltip id="button-tooltip" {...props}>
			{helpText}
		</Tooltip>
	);
	return (
		<OverlayTrigger
			placement="right"
			delay={{ show: 250, hide: 400 }}
			overlay={renderTooltip}
		>
			<div className="helpIcon">?</div>
		</OverlayTrigger>
	);
};
